import {
  GET_CLOUD_DOCUMENTS_INIT,
  GET_CLOUD_DOCUMENTS_SUCCESS,
  GET_CLOUD_DOCUMENTS_FAILED,
  UPLOAD_FILE_DECK_INIT,
  UPLOAD_FILE_DECK_SUCCESS,
  UPLOAD_FILE_DECK_FAILED,
} from "./constants";

export const initialState = {
  loading: false,
  getDocuments: [],
  fileDeckLoading: false,
};

export default function CloudDocumentStore(state = initialState, action) {
  switch (action.type) {
    case GET_CLOUD_DOCUMENTS_INIT:
      return { ...state, loading: true };
    case GET_CLOUD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        getDocuments: action.payload,
      };
    case GET_CLOUD_DOCUMENTS_FAILED:
      return { ...state, loading: false };
    case UPLOAD_FILE_DECK_INIT:
      return { ...state, fileDeckLoading: true };
    case UPLOAD_FILE_DECK_SUCCESS:
      return {
        ...state,
        fileDeckLoading: false,
        getDocuments: [...state.getDocuments, action.payload],
      };
    case UPLOAD_FILE_DECK_FAILED:
      return { ...state, fileDeckLoading: false };
    default:
      return state;
  }
}
